import * as yup from "yup";
import { CurrencyType } from "../../../../common/enums";

export const eventArrivalConfirmationFormSchema = yup
  .object({
    userId: yup.number().required().min(1).defined(),
    eventId: yup.number().required().min(1).defined(),
    paymentTypeId: yup.number().required().min(1).defined(),
    price: yup.number().nullable().min(0).defined(),
    currencyId: yup.number().nullable().defined(),
    onlyPaid: yup.boolean().required().defined(),
    subscriptionId: yup.number().optional().defined(),
    toggleUserReliability: yup.boolean().nullable().defined(),
  })
  .required();

export type IEventArrivalConfirmationFormModel = yup.InferType<
  typeof eventArrivalConfirmationFormSchema
>;

export const eventArrivalConfirmationDefaultValues: IEventArrivalConfirmationFormModel =
  {
    userId: 0,
    eventId: 0,
    paymentTypeId: 0,
    price: 0,
    currencyId: CurrencyType.EUR,
    onlyPaid: false,
    subscriptionId: 0,
    toggleUserReliability: null,
  };
